"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIsToggleFavoritsDisabled = void 0;
var _isEqual = _interopRequireDefault(require("lodash/isEqual"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var useIsToggleFavoritsDisabled = exports.useIsToggleFavoritsDisabled = function useIsToggleFavoritsDisabled(_ref) {
  var fillOptions = _ref.fillOptions,
    favorits = _ref.favorits,
    options = _ref.options,
    selectedOptions = _ref.selectedOptions,
    getOptionValue = _ref.getOptionValue;
  return function () {
    var isDisabled;
    var result = fillOptions({
      favorits: favorits,
      options: options,
      getOptionValue: getOptionValue
    });
    if ((0, _isEqual["default"])(result, selectedOptions)) {
      isDisabled = true;
    }
    if ((0, _isEmpty["default"])(selectedOptions) || selectedOptions.length >= 2 || !(0, _isEqual["default"])(result, selectedOptions)) {
      isDisabled = false;
    }
    return isDisabled;
  };
};